import { required } from '@vee-validate/rules'

export function mergeRules(originalRules?: (value: string) => boolean | string, requiredError?: string) {
  if (!requiredError) return originalRules
  if (!originalRules) return (value: string) => required(value) || requiredError
  return (value: string) => {
    return required(value) ? originalRules(value) : requiredError
  }
}
